const brVendors = {
  vendors: {
    label: {
      title: 'Fornecedor',
      name: 'Nome',
      email: 'E-mail',
      financialEmail: 'E-mail financeiro',
      document: 'Documento',
      createdAt: 'Criado em',
      description: 'Descrição',
      hostServicePhone: 'Telefone do host',
      customerServicePhone: 'Telefone do cliente',
      vendorLogo: 'Logo do fornecedor',
      details: 'Detalhes',
      paymentInfo: 'Informações de pagamento'
    },

    action: {
      cancel: 'Cancelar',
      edit: 'Editar fornecedor',
      create: 'Novo fornecedor',
      delete: 'Remover fornecedor',
      loading: 'Carregando fornecedor',
      save: 'Salvar',
      update: 'Atualizar',
    },

    hints: {
      delete: 'Deseja mesmo apagar este fornecedor?',
      vendorNotFound: 'Fornecedor não encontrado',
    },

    messages: {
      successfullyCreated: 'Fornecedor criado com sucesso',
      successfullyUpdated: 'Fornecedor atualizado com sucesso',
      successfullyDeleted: 'Fornecedor removido com sucesso',
    },
  },
}

export default brVendors
